// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3mF48","signatureBlock":"Footer_signatureBlock__1bSzE","signature":"Footer_signature__13rdB"};